var riot = require("riot");

riot.tag2('ahv-login-form', '<div class="container" id="ahv-login-form"> <div class="row"> <div class="col-lg-12"> <form onsubmit="{authenticate}"> <div class="form-group"> <label for="username">Bruker</label> <input id="username" class="form-control" placeholder="Bruker"> </div> <div class="form-group"> <label for="password">Passord</label> <input id="password" class="form-control" placeholder="Passord" type="password"> </div> <button class="btn btn-primary" type="submit">Logg inn</button> </form> </div> </div> </div>', '', '', function(opts) {
    require("./LoginFormController").init(this);
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/loginForm/ahv-login-form.tag
 ** module id = 62
 ** module chunks = 0
 **/